import React, { useState } from 'react';
import { householdAPI } from '../services/api';
import './Modal.css';

function JoinHouseholdModal({ onClose, onSuccess }) {
  const [inviteCode, setInviteCode] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [pendingMessage, setPendingMessage] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setPendingMessage('');
    setLoading(true);

    try {
      const response = await householdAPI.join(inviteCode);
      
      // Check if request is pending approval
      if (response.data.status === 'pending') {
        setPendingMessage(response.data.message);
        // Don't close - show success message
      } else {
        // Direct approval (for backwards compatibility or future use)
        if (onSuccess) onSuccess(response.data);
        setInviteCode('');
        onClose();
      }
    } catch (err) {
      setError(err.response?.data?.detail || 'Failed to join household');
    } finally {
      setLoading(false);
    }
  };

  const handleClose = () => {
    if (pendingMessage && onSuccess) {
      onSuccess({ pending: true });
    }
    onClose();
  };

  return (
    <div className="modal-overlay" onClick={handleClose}>
      <div className="modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>🔗 Join Household</h2>
          <button className="close-btn" onClick={handleClose}>&times;</button>
        </div>

        {error && <div className="error-message">{error}</div>}

        {pendingMessage ? (
          <div className="pending-success">
            <div className="pending-icon">⏳</div>
            <h3>Request Submitted!</h3>
            <p>{pendingMessage}</p>
            <p className="pending-note">
              The household owner will review your request. 
              You'll be notified once approved.
            </p>
            <button className="btn-submit" onClick={handleClose}>
              Got it!
            </button>
          </div>
        ) : (
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label>Invite Code</label>
              <input
                type="text"
                value={inviteCode}
                onChange={(e) => setInviteCode(e.target.value)}
                placeholder="Enter the invite code"
                required
                autoFocus
              />
            </div>

            <div className="modal-actions">
              <button type="button" onClick={handleClose} className="btn-cancel">
                Cancel
              </button>
              <button type="submit" disabled={loading} className="btn-submit">
                {loading ? 'Submitting...' : 'Request to Join'}
              </button>
            </div>
          </form>
        )}

        {!pendingMessage && (
          <div className="modal-info">
            <p>💡 Ask a household member for their invite code!</p>
            <p className="small-text">Your request will be sent to the owner for approval.</p>
          </div>
        )}
      </div>
    </div>
  );
}

export default JoinHouseholdModal;
